import loadable from '@loadable/component'

// export { default as Header } from "./Header/Header"
// export { default as Background } from "./GuaranteedIncome/Background"
// export { default as IncomePlan } from "./GuaranteedIncome/IncomePlan"
// export { default as Benefits } from "./GuaranteedIncome/Benefits"
// export { default as Calculator } from "./GuaranteedIncome/Calculator"

const Header = loadable(() => import("./Header/Header"))
const Calculator = loadable(() => import("./GuaranteedIncome/Calculator"))
const Background = loadable(() => import("./GuaranteedIncome/Background"))
const IncomePlan = loadable(() => import("./GuaranteedIncome/IncomePlan"))
const Benefits = loadable(() => import("./GuaranteedIncome/Benefits"))

const Steps = loadable(() => import("./Steps/Steps"))
const WhyUsHeader = loadable(() => import("./WhyUs/WhyUsHeader"))
const WhyUs = loadable(() => import("./WhyUs/WhyUs"))
const Recommended = loadable(() => import("./Recommended/Recommended.js"))
const Glossary = loadable(() => import("./Glossary/Glossary.js"))
const WhatIs = loadable(() => import("./WhatIS/WhatIs.js"))
const PlanWorks = loadable(() => import("./PlanWorks/PlanWorks.js"))
const VideoModal = loadable(() => import("./PlanWorks/VideoModal.js"))
const Faq = loadable(() => import("./Faq/Faq.js"))
const TalkToExpertModal = loadable(() => import("./Header/TalkToExpertModal"))
const Footer = loadable(() => import("./Footer/Footer"))
const QuoteModal = loadable(() => import("./QuoteScreen/QuoteModal.js"))
const Disclaimer = loadable(() => import("./Disclaimer/Disclaimer"))
const KeyTerms = loadable(() => import("./KeyTerms/KeyTerms.js"))
const AppFormBOO = loadable(() => import("./AppForm/AppFormBOO"))
const SuitabilityModal = loadable(() => import("./Suitability/SuitabilityModal"))
const RetirementGuide = loadable(() => import("./RetirementGuide/RetirementGuide.js"))
const ErrorBoundary = loadable(() => import("./ErrorBoundary/ErrorBoundary.js"))

const ClaimModal = loadable(() => import("./ClaimModal/ClaimModal"))
const ExtraHeader = loadable(() => import("./Header/ExtraHeader"))
const OptionalLeadFrame = loadable(() => import("./QuoteScreen/OptionalLeadFrame"))
const RemoteHandOverAppForm = loadable(() => import("./RemoteHandOverAppForm/RemoteHandOverAppForm"))

export {
  Header,
  Calculator,
  Background,
  IncomePlan,
  Benefits,
  ClaimModal,
  Steps,
  WhyUsHeader,
  WhyUs,
  Recommended,
  Glossary,
  WhatIs,
  PlanWorks,
  VideoModal,
  Faq,
  TalkToExpertModal,
  Footer,
  QuoteModal,
  Disclaimer,
  KeyTerms,
  AppFormBOO,
  SuitabilityModal,
  RetirementGuide,
  ErrorBoundary,
  ExtraHeader,
  OptionalLeadFrame,
  RemoteHandOverAppForm
}
